module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('header', {
    staticClass: "main-header"
  }, [_vm._m(0), _vm._v(" "), _c('nav', {
    staticClass: "navbar navbar-static-top",
    attrs: {
      "role": "navigation"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "navbar-custom-menu"
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [_c('li', [_c('a', {
    attrs: {
      "href": "#",
      "title": "Sair"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.logout()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-sign-out"
  }), _vm._v(" sair")])])])])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "logo"
  }, [_c('span', {
    staticClass: "logo-mini"
  }, [_vm._v("I")]), _vm._v(" "), _c('span', {
    staticClass: "logo-lg"
  }, [_c('img', {
    attrs: {
      "src": "/static/img/logo-interna.png"
    }
  })])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "sidebar-toggle",
    attrs: {
      "href": "#",
      "data-toggle": "offcanvas",
      "role": "button"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2a31ba50","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/template/Header.vue
// module id = 652
// module chunks = 1